export default __webpack_public_path__ + "static/media/homepageFormations.38f111ff.png";